import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

export class ColumnAssetId extends CampaignuiBaseColumn {
  constructor({
    i18n,
  }) {
    const title = i18n.getString('ColumnName_AssetId');

    super({
      name: 'AssetId',
      property: 'AssetId',
      title,
      type: 'string',
      bodyClasses: 'grid-column-AssetId',
    });
  }

  get property() {
    return {
      get: ({
        Asset,
      }) => Asset.IdString,
    };
  }

  template({ value }) {
    return value || '-';
  }
}
